import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Button, Modal } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";
import swal from "sweetalert2";


import {
  UserEditSkeleton,
  DetailSkeleton,
  UserButtonLoading,
} from "../../partials/loadings/ComponentLoading.js";

// select style
const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: "100px",
    minWidth: "15rem",
  }),
};

const animatedComponent = makeAnimated();

// ===== OPTIMIZED MENU LIST =====
// Defined at module level so React doesn't recreate on every render
// (recreating causes scroll reset and prevents option selection)
const MAX_VISIBLE_OPTIONS = 50;
const OptimizedMenuList = (props) => {
  const { children } = props;
  const childArray = React.Children.toArray(children);
  if (childArray.length <= MAX_VISIBLE_OPTIONS) {
    return <components.MenuList {...props}>{children}</components.MenuList>;
  }
  const limited = childArray.slice(0, MAX_VISIBLE_OPTIONS);
  return (
    <components.MenuList {...props}>
      {limited}
      <div style={{
        padding: '8px 12px', textAlign: 'center', color: '#94a3b8',
        fontSize: '0.78rem', borderTop: '1px solid #f1f5f9', background: '#f8fafc'
      }}>
        Ketik untuk menyaring {childArray.length - MAX_VISIBLE_OPTIONS} opsi lainnya...
      </div>
    </components.MenuList>
  );
};
const optimizedComponents = { MenuList: OptimizedMenuList };

function captFirstLetter(string) {
  return (
    string
      .toString()
      .charAt(0)
      .toUpperCase() + string.slice(1)
  );
}

const dataKurikulum = [
  { value: "K13", label: "K13" },
  { value: "Merdeka", label: "Merdeka" },
];

const handleClear = () => {
  setOptions((currentOptions) =>
    currentOptions.filter((currentOption) => !selected.includes(currentOption))
  );
  setSelected([]);
};

export default class PenugasanGuru extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // url API
      url: `${conf.uri_backend}api/v1/penugasan/table_penugasan/`,
      url_get_guru: `${conf.uri_backend}api/v1/penugasan/nama_pekerja/GU/`,
      url_get_penugasan: `${conf.uri_backend}api/v1/penugasan/select_penugasan/GU/1`,
      url_get_pengampu: `${conf.uri_backend}api/v1/penugasan/select_pengampu/GU/`,
      url_get_kurikulum: `${conf.uri_backend}api/v1/penugasan/select_kurikulum/`,
      url_create_penugasan: `${conf.uri_backend}api/v1/penugasan/create`,
      url_detail_penugasan: `${conf.uri_backend}api/v1/penugasan/edit/`,
      url_put_penugasan: `${conf.uri_backend}api/v1/penugasan/update/`,
      url_delete_penugasan: `${conf.uri_backend}api/v1/penugasan/delete/`,
      url_delete_penugasan_m: `${conf.uri_backend}api/v1/penugasan/penugasan_destroy/`,
      url_pindah_ta: `${conf.uri_backend}api/v1/penugasan/tahun_ajaran/update/`,
      url_set_inisial: `${conf.uri_backend}api/v1/penugasan/set-inisial`,
      // modal
      modal_tambah: false,
      modal_materi: false,
      modal_edit: false,
      // bind data form
      id_penugasan: "",
      nama: "",
      nama_guru: "",
      penugasan: "",
      penugasan_nama: "",
      pengampu: "",
      pengampu_merdeka: "",
      tahun_ajaran: "",
      materi: "",
      tahun_ajaran_lama: "",
      guru_id_lama: "",
      kurikulum_select: null,
      tahunSekarang: new Date().getFullYear(),
      // Selected Select Edit data
      dataEditMateri: [],
      // alert
      show_alert: false,
      title_alert: "",
      message_alert: {},
      icon_alert: "",
      // search and filter
      searchText: "",
      filterTahunAjaran: "",
      filterPindahTa: "",
      filterPenugasan: "",
      filterPengamuSc: "",
      simpleLoading: false,
      loading_button: null,
      isChecked: false,
      check_item: false,
      checkAll: false,
      loading_check: false,
      loading_delete: false,
      // filter chip toggles
      showFilterTA: false,
      showFilterPenugasan: false,
      showFilterMapel: false,

      defaultValuePengampuEdit: {},
      kurikulum: [],
    };
    // Bind data
    this.nama = this.nama.bind(this);
    this.penugasan = this.penugasan.bind(this);
    this.kurikulum = this.kurikulum.bind(this);
    this.pengampu = this.pengampu.bind(this);
    this.tahun_ajaran = this.tahun_ajaran.bind(this);
    // Create Funtion
    this.showModalTambah = this.showModalTambah.bind(this);
    this.hideModalTambah = this.hideModalTambah.bind(this);
    this.create_penugasan = this.create_penugasan.bind(this);
    // Show Materi
    this.showModalMateri = this.showModalMateri.bind(this);
    this.hideModalMateri = this.hideModalMateri.bind(this);
    // Show Edit
    this.showModalEdit = this.showModalEdit.bind(this);
    this.hideModalEdit = this.hideModalEdit.bind(this);
    this.update_penugasan = this.update_penugasan.bind(this);
    // Get List data from   DB
    this.getNamaGuru = this.getNamaGuru.bind(this);
    this.getPenugasan = this.getPenugasan.bind(this);
    this.getPengampu = this.getPengampu.bind(this);
    // Delete Penugasan
    this.deletePenugasan = this.deletePenugasan.bind(this);
    // filter and search
    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);
    this.filterPenugasan = this.filterPenugasan.bind(this);
    this.filterPengamuSc = this.filterPengamuSc.bind(this);
    this.filterPindahTa = this.filterPindahTa.bind(this);
    this.searchText = this.searchText.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    // get option filter
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);

    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.pindahTa = this.pindahTa.bind(this);
    this.savePindahTa = this.savePindahTa.bind(this);
    this.hideModalTa = this.hideModalTa.bind(this);
    this.deleteMulti = this.deleteMulti.bind(this);

    this.setInisial = this.setInisial.bind(this);
  }

  componentDidMount() {
    // get session user
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, function () {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/` +
                this.state.data_session.access_to,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    npsn_id_select: res.data.npsn,
                  },
                  function () {
                    this.dt.fetchEntities();
                    this.getNamaGuru(this.state.institusi_id_select);
                    this.getTahunAjaranNow();
                    this.getPenugasan();
                  }
                );
              });
          });
        });
    }
  }

  getTahunAjaranNow() {
    var ta = [];
    var u = this.state.tahunSekarang + 1;
    var tahun_sekarang = this.state.tahunSekarang + 1;

    for (var i = tahun_sekarang; i >= 2005; i--) {
      u = u - 1;
      ta.push({ value: u + " / " + i, label: u + " / " + i });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  // Bind data form
  nama(e) {
    this.setState({ nama: e.value });
  }

  penugasan(e) {
    this.setState({ penugasan: e });
  }

  selectRef = null;
  clearValue = () => {
    this.selectRef?.select.clearValue();
  };

  kurikulum(e) {
    // Always update both kurikulum and kurikulum_select
    this.setState({ kurikulum: e, kurikulum_select: e });

    // Load pengampu options for any newly added kurikulum
    if (e?.length) {
      // Get the newly added kurikulum (last one)
      const newKurikulum = e[e.length - 1]?.value;
      this.getPengampu(newKurikulum);
    }
  }

  pengampu(e, kurikulum) {
    console.log("ss", e);
    console.log("ssaa", kurikulum);
    if (kurikulum.value == "K13") this.setState({ pengampu: e });
    else this.setState({ pengampu_merdeka: e });
  }

  tahun_ajaran(e) {
    this.setState({ tahun_ajaran: e.value });
  }

  // Get List Nama Guru from DB
  getNamaGuru(id) {
    axios.get(this.state.url_get_guru + id, {
      headers: { Authorization: tokenApi },
    }).then((res) => {
      this.setState({ data_nama_guru: res.data });
    });
  }

  // Get List Penugasan from DB
  getPenugasan() {
    axios.get(this.state.url_get_penugasan, {
      headers: { Authorization: tokenApi },
    }).then((res) => {
      this.setState({ data_penugasan: res.data });
    });
  }

  // Get List Pengampu from DB
  getPengampu(e) {
    const kurikulum = e;
    const jenjangId = String(this.state.jenjang_id_select ?? '').trim();
    const jenjangMap = {
      "1": "0", // TK
      "2": "1", // SD
      "3": "2", // SMP
      "4": "3", // SMA
      "5": "4", // SMK
    };

    const jenjangPengampu = jenjangMap[jenjangId];

    if (!jenjangPengampu || !kurikulum) {
      console.warn("jenjang atau kurikulum kosong untuk pengampu:", {
        jenjang_id_select: this.state.jenjang_id_select,
        kurikulum,
      });
      return;
    }

    axios
      .get(`${this.state.url_get_pengampu}${jenjangPengampu}/${kurikulum}`, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (kurikulum === "K13") {
          this.setState({ data_pengampu: res.data });
        } else {
          this.setState({ data_pengampu_merdeka: res.data });
        }
      })
      .catch((err) => {
        console.error("Gagal ambil pengampu:", err);
      });
  }

  // Create Funtion
  showModalTambah() {
    this.setState({ modal_tambah: true });
  }

  hideModalTambah() {
    this.setState({
      modal_tambah: false,
      nama: "",
      penugasan: "",
      pengampu: "",
      tahun_ajaran: "",
      kurikulum: "",
    });
  }

  alertMessage(e) {
    let message = null;

    switch (e.status) {
      case 422:
        message = e.data.messages[0];
        break;
      case 500:
        message =
          "Ada yang Salah, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 404:
        message = "Url Not Found, Coba Hubungi Admin 😊";
        break;
      case 401:
        message =
          "Nauthorized, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 400:
        message =
          "Koneksi Buruk, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 408:
        message =
          "Request Timeout, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 429:
        message =
          "Too Many Request, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 405:
        message =
          "Method Tidak Diperbolehkan, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
    }

    this.setState({
      show_alert: true,
      title_alert: "Gagal",
      icon_alert: "error",
      message_alert: message,
      simpleLoading: false,
    });
  }

  // Tambah Penugasan Guru
  create_penugasan(event) {
    event.preventDefault();
    this.setState({ simpleLoading: true });

    var nama = this.state.nama;
    var penugasan = this.state.penugasan;
    var kurikulum = this.state.kurikulum;
    var pengampuCollect = "";

    if (this.state.pengampu !== "") {
      this.state.pengampu.map((pengampu, index) => {
        pengampuCollect += "," + pengampu.value;
      });
    }

    if (this.state.pengampu_merdeka !== "") {
      this.state.pengampu_merdeka.map((pengampu, index) => {
        pengampuCollect += "," + pengampu.value;
      });
    }
    console.log(pengampuCollect);
    var tahun_ajaran = this.state.tahun_ajaran;

    axios
      .post(
        this.state.url_create_penugasan,
        {
          guru_id: nama,
          penugasan_id: penugasan,
          kurikulum: kurikulum,
          id_mapel: pengampuCollect,
          tahun_ajaran: tahun_ajaran,
          institusi_id: this.state.institusi_id_select,
          created_at: new Date(),
          created_by: this.state.institusi_id_select,
        },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        // console.log(this.state.pengampu)
        // console.log(this.state.pengampu_merdeka)
        console.log(this.state.kurikulum);
        this.setState({
          show_alert: true,
          title_alert: "Berhasil",
          icon_alert: "success",
          message_alert: res.data.messages[0],
        });
        this.hideModalTambah();
        this.dt.fetchEntities();
        this.setState({ simpleLoading: false });
      })
      .catch((err) => {
        this.setState({ simpleLoading: false });
        this.alertMessage(err.response);
      });
  }

  // Materi Show Funtion
  showModalMateri(data) {
    this.setState({ loading_view: data });
    axios
      .get(this.state.url_detail_penugasan + data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          // Materi
          var materiCollect = [];
          var pengampuK13 = [];
          var pengampuMerdeka = [];
          var kurikulumCollect = [];
          res.data.data.materi.map((mapel, index) => {
            materiCollect.push(mapel);
            kurikulumCollect.push(mapel.kurikulum);

            kurikulumCollect.map((value, index) => {
              return { value }
            })

            // if (kurikulumCollect == ['K13']) {
            //   pengampuK13.push({ value: mapel.id_materi, label: mapel.materi });
            // }

            // if (kurikulumCollect == ['Merdeka']) {
            //   pengampuMerdeka.push({ value: mapel.id_materi, label: mapel.materi });
            // }

            // if (mapel.kurikulum == 'K13' || mapel.kurikulum == 'Merdeka') {
            //   pengampuMerdeka.push({ value: mapel.id_materi, label: mapel.materi });
            //   pengampuK13.push({ value: mapel.id_materi, label: mapel.materi });
            // } else {
            //   pengampuMerdeka.push({ value: mapel.id_materi, label: mapel.materi });
            // }

            if (mapel.kurikulum == "K13")
              pengampuK13.push(mapel);
            else
              pengampuMerdeka.push(mapel);
          });

          console.log(res.data, "Data Kabeh");

          this.setState({
            modal_materi: true,
            loading_view: false,
            materiK13: pengampuK13,
            materiMerdeka: pengampuMerdeka,
            activeMapelTab: null,
          });
          console.log(this.state.materiK13, "Kurikulum 2013");
          console.log(this.state.materiMerdeka, "Kurikulum Merdeka");
        }
      });
  }

  hideModalMateri() {
    this.setState({ modal_materi: false, dataEditMateri: [] });
  }

  // Edit Funtion
  update_penugasan(event) {
    event.preventDefault();
    this.setState({ loading_saveedit: true });
    console.log(this.state.pengampu);

    var pengampuCollect = "";

    if (this.state.pengampu !== "") {
      this.state.pengampu.map((pengampu, index) => {
        pengampuCollect += "," + pengampu.value;
      });
    }

    if (this.state.pengampu_merdeka !== "") {
      this.state.pengampu_merdeka.map((pengampu, index) => {
        pengampuCollect += "," + pengampu.value;
      });
    }

    var tahun_ajaran = this.state.tahun_ajaran;
    // var kurikulum    = this.state.kurikulum

    axios
      .put(
        this.state.url_put_penugasan + this.state.id_penugasan,
        {
          // kurikulum         : this.state.kurikulum ? this.state.kurikulum.value : this.state.kurikulum_select.value,
          kurikulum: this.state.kurikulum,
          guru_id: this.state.nama,
          penugasan_id: this.state.penugasan,
          id_mapel: pengampuCollect,
          tahun_ajaran: this.state.tahun_ajaran,
          tahun_ajaran_lama: this.state.tahun_ajaran_lama,
          guru_id_lama: this.state.guru_id_lama,
          institusi_id: this.state.institusi_id_select,
          updated_at: new Date(),
          updated_by: this.state.institusi_id_select,
        },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({
          show_alert: true,
          title_alert: "Berhasil",
          icon_alert: "success",
          message_alert: res.data.messages[0],
          loading_saveedit: false,
        });
        this.hideModalEdit();
        this.dt.fetchEntities();

        console.log(this.state.kurikulum);
      })
      .catch((err) => {
        this.setState({ loading_saveedit: false });
        this.alertMessage(err.response);
      });
  }

  showModalEdit(data) {
    this.setState({ loading_edit: true, modal_edit: true });
    var nama = [];
    var penugasan = [];
    var tahunAjaran = [];
    var pengampuK13 = [];
    var pengampuMerdeka = [];
    var kurikulum = [];
    axios
      .get(this.state.url_detail_penugasan + data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          let kurikulumFirstLetter = captFirstLetter(
            res.data.data.kurikulum ?? "K13"
          );
          nama.push({
            value: res.data.data.guru_id,
            label: res.data.data.nama_guru,
          });
          penugasan.push({
            value: res.data.data.penugasan_id,
            label: res.data.data.nama_penugasan_guru,
          });
          // console.log("cok", res.data.data.kurikulum.filter(x=>x!==""))
          kurikulum.push({
            value: res.data.data.kurikulum.filter(x => x !== "") ?? "K13",
            label: kurikulumFirstLetter,
          });
          // kurikulum.push({value: res.data.data.kurikulum, label:res.data.data.kurikulum});
          tahunAjaran.push({
            value: res.data.data.tahun_ajaran,
            label: res.data.data.tahun_ajaran,
          });

          res.data.data.materi.map((mapel, index) => {
            if (mapel.kurikulum == "K13")
              pengampuK13.push({ value: mapel.id_materi, label: mapel.materi });
            else
              pengampuMerdeka.push({ value: mapel.id_materi, label: mapel.materi });
          });

          this.setState({
            pengampu: pengampuK13,
            pengampu_merdeka: pengampuMerdeka,
          });

          let dtKurikulum =
            res.data.data?.kurikulum.filter(x => x !== "").map((e) => {
              return { label: e, value: e };
            }) ?? [];



          this.setState(
            {
              id_penugasan: res.data.data.id,
              nama: res.data.data.guru_id,
              penugasan: penugasan,
              tahun_ajaran: res.data.data.tahun_ajaran,
              nama_select: nama,
              penugasan_select: penugasan,
              tahun_ajaran_select: tahunAjaran,
              // pengampu_select       : pengampu,
              // pengampu_select       : dtPengampu,
              // pengampu              : dtPengampu,
              tahun_ajaran_lama: res.data.data.tahun_ajaran,
              guru_id_lama: res.data.data.guru_id,
              kurikulum_select: dtKurikulum,
              kurikulum: dtKurikulum,
            },
            function () {
              // Load pengampu options for each kurikulum type
              dtKurikulum.forEach((kur) => {
                this.getPengampu(kur.value);
              });
              this.setState({ loading_edit: false });
            }
          );
        } else {
          console.log("error");
        }
      });
  }

  hideModalEdit() {
    this.setState({
      modal_edit: false,
      nama: "",
      penugasan: "",
      pengampu: "",
      tahun_ajaran: "",
      nama_select: "",
      penugasan_select: "",
      tahun_ajaran_select: "",
      pengampu: "",
    });

    this.state.kurikulum_select = null;
  }

  deletePenugasan(data) {
    this.setState({ loading_delete: true });

    swal
      .fire({
        title: "Peringatan",
        text: "Apakah anda yakin menghapus penugasan tersebut?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Iya`,
        cancelButtonText: "Batal",
      })
      .then((result) => {
        if (result.value == true) {
          axios
            .delete(this.state.url_delete_penugasan + data, {
              headers: { Authorization: tokenApi },
            })
            .then((res) => {
              this.setState({
                show_alert: true,
                title_alert: "Berhasil",
                icon_alert: "success",
                message_alert: res.data.messages[0],
                loading_delete: false,
              });
              this.dt.resetPage(
                `&query=${document.getElementById("search").value
                }&tahun_ajaran=${this.state.filterTahunAjaran}&penugasan=${this.state.filterPenugasan
                }&mapel=${this.state.filterPengamuSc}`
              );
            })
            .catch((err) => {
              this.setState({ loading_delete: false });
              this.alertMessage(err.response);
            });
        } else if (result.dismiss == "cancel") {
          this.setState({ loading_delete: false });
        } else if (result.dismiss == "backdrop") {
          this.setState({ loading_delete: false });
        }
      });
  }

  searchText() {
    this.dt.resetPage(
      `&query=${document.getElementById("search").value}&tahun_ajaran=${this.state.filterTahunAjaran
      }&penugasan=${this.state.filterPenugasan}&mapel=${this.state.filterPengamuSc
      }`
    );
    this.dt.loading();
  }

  filterTahunAjaran(e) {
    if (e) {
      this.setState({ filterTahunAjaran: e.value });
    } else {
      this.setState({ filterTahunAjaran: "" }, () => { this.applyFilter(); });
    }
  }

  filterPindahTa(e) {
    if (e) {
      this.setState({ filterPindahTa: e.value });
    } else {
      this.setState({ filterPindahTa: "" });
    }
  }

  filterPenugasan(e) {
    if (e) {
      this.setState({ filterPenugasan: e.value });
    } else {
      this.setState({ filterPenugasan: "" }, () => { this.applyFilter(); });
    }
  }

  filterPengamuSc(e) {
    if (e) {
      this.setState({ filterPengamuSc: e.value });
    } else {
      this.setState({ filterPengamuSc: "" }, () => { this.applyFilter(); });
    }
  }

  setFilter(e) {
    if (e && e.preventDefault) e.preventDefault();
    this.applyFilter();
  }

  applyFilter() {
    this.setState({
      loading_button: this.dt.loadingIndicator(),
    });
    this.dt.loading();
    this.dt.resetPage(
      `&query=${document.getElementById("search").value}&tahun_ajaran=${this.state.filterTahunAjaran
      }&penugasan=${this.state.filterPenugasan}&mapel=${this.state.filterPengamuSc
      }`
    );
  }

  checkAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: true, loading_check: false });
    });
  }

  unCheckAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: false, loading_check: false });
    });
  }

  deleteMulti() {
    this.setState({ loading_delete: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_delete: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin menghapus penugasan yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_delete_penugasan_m,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert: res.data.messages[0],
                    loading_delete: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage(
                    `&query=${document.getElementById("search").value
                    }&tahun_ajaran=${this.state.filterTahunAjaran}&penugasan=${this.state.filterPenugasan
                    }&mapel=${this.state.filterPengamuSc}`
                  );
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    checkAll: false,
                    loading_delete: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage(
                    `&query=${document.getElementById("search").value
                    }&tahun_ajaran=${this.state.filterTahunAjaran}&penugasan=${this.state.filterPenugasan
                    }&mapel=${this.state.filterPengamuSc}`
                  );
                }
              })
              .catch((err) => {
                this.setState({ loading_delete: false });
                this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_delete: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_delete: false });
          }
        });
    }
  }

  hideModalTa() {
    this.setState({
      modal_pindah_ta: false,
    });
  }

  pindahTa() {
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_delete: false,
      });
    } else {
      this.setState({
        modal_pindah_ta: true,
      });
    }
  }

  savePindahTa() {
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    axios
      .post(
        this.state.url_pindah_ta,
        {
          id: vals,
          institusi_id: this.state.institusi_id_select,
          tahun_ajaran: this.state.filterPindahTa,
        },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status == false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages[0],
            loading_delete: false,
            checkAll: false,
          });
          this.dt.loading();
          this.dt.resetPage(
            `&query=${document.getElementById("search").value}&tahun_ajaran=${this.state.filterTahunAjaran
            }&penugasan=${this.state.filterPenugasan}&mapel=${this.state.filterPengamuSc
            }`
          );
        } else {
          this.setState({
            show_alert: true,
            title_alert: "Berhasil",
            icon_alert: "success",
            message_alert: res.data.messages[0],
            loading_delete: false,
            checkAll: false,
          });
          this.dt.loading();
          this.dt.resetPage(
            `&query=${document.getElementById("search").value}&tahun_ajaran=${this.state.filterTahunAjaran
            }&penugasan=${this.state.filterPenugasan}&mapel=${this.state.filterPengamuSc
            }`
          );
        }
      })
      .catch((err) => {
        this.setState({ loading_delete: false });
        this.alertMessage(err.response);
      });
  }

  setInisial(e, guru_id) {
    if (e.length == 3) {
      axios
        .post(
          this.state.url_set_inisial,
          { guru_id: guru_id, inisial: e },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.dt.loading();
          this.dt.resetPage(
            `&query=${document.getElementById("search").value}&tahun_ajaran=${this.state.filterTahunAjaran
            }&penugasan=${this.state.filterPenugasan}&mapel=${this.state.filterPengamuSc
            }`
          );
        })
        .catch((err) => {
          this.setState({ loading_delete: false });
          this.alertMessage(err.response);
        });
    }
  }

  render() {
    const pgsSelectStyles = {
      control: (styles, state) => ({
        ...styles,
        borderRadius: '12px',
        border: state.isFocused ? '1.5px solid #3b82f6' : '1.5px solid #e2e8f0',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(59,130,246,0.1)' : 'none',
        minHeight: '42px',
        fontSize: '0.875rem',
        '&:hover': { borderColor: '#93c5fd' },
      }),
      menu: (styles) => ({ ...styles, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,0.12)' }),
      option: (styles, state) => ({ ...styles, fontSize: '0.85rem', background: state.isSelected ? '#014282' : state.isFocused ? '#eff6ff' : '#fff', color: state.isSelected ? '#fff' : '#334155' }),
      multiValue: (styles) => ({ ...styles, borderRadius: '8px', background: '#eff6ff' }),
      multiValueLabel: (styles) => ({ ...styles, color: '#1d4ed8', fontWeight: 600, fontSize: '0.78rem' }),
      multiValueRemove: (styles) => ({ ...styles, color: '#3b82f6', '&:hover': { background: '#dbeafe', color: '#1d4ed8' } }),
      placeholder: (styles) => ({ ...styles, color: '#94a3b8', fontSize: '0.85rem' }),
      menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
    };

    const pgsSelectStylesGreen = {
      ...pgsSelectStyles,
      multiValue: (styles) => ({ ...styles, borderRadius: '8px', background: '#ecfdf5' }),
      multiValueLabel: (styles) => ({ ...styles, color: '#059669', fontWeight: 600, fontSize: '0.78rem' }),
      multiValueRemove: (styles) => ({ ...styles, color: '#10b981', '&:hover': { background: '#d1fae5', color: '#059669' } }),
    };


    // Pengampu option label formatter - context-aware for performance
    // "menu" context = full JSX in dropdown, "value" context = simple text with group badge
    const formatMapelLabel = (option, { context }) => {
      const nama = option.mp || option.label || '';
      if (context === 'value') {
        // Selected tag: show name + small group badge
        const grp = option.kmp;
        if (grp) {
          return (
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {nama}
              <span style={{
                fontSize: '0.62rem', background: '#e0f2fe', color: '#0369a1',
                padding: '0 4px', borderRadius: '3px', fontWeight: 600, whiteSpace: 'nowrap'
              }}>{grp}</span>
            </span>
          );
        }
        return nama;
      }
      // Menu dropdown: rich JSX
      const kode = option.indeks_mpk;
      if (kode) {
        return (
          <div className="pgs-option-mapel">
            <span className="pgs-option-nama">{nama}</span>
            <span className="pgs-option-kode">{kode}</span>
          </div>
        );
      }
      return nama;
    };

    // Fast custom filter - search on mp name and indeks_mpk code
    const filterMapelOption = (option, inputValue) => {
      if (!inputValue) return true;
      const search = inputValue.toLowerCase();
      const mp = (option.data?.mp || option.label || '').toLowerCase();
      const kode = (option.data?.indeks_mpk || '').toLowerCase();
      return mp.includes(search) || kode.includes(search);
    };

    // Group flat option arrays into react-select grouped format
    // Groups by: "Jenjang - Kelompok - Jenis - Kelas X"
    const groupMapelOptions = (options) => {
      if (!options || !options.length) return [];
      // Check if structured data is available
      if (!options[0]?.kmp) return options; // fallback: ungrouped
      const groups = {};
      options.forEach((opt) => {
        const key = `${opt.jenjang || '?'} - ${opt.kmp || '?'} - ${opt.jkmp || '?'} - Kelas ${opt.kelas || '?'}`;
        if (!groups[key]) groups[key] = { label: key, options: [] };
        groups[key].options.push(opt);
      });
      return Object.values(groups);
    };

    // Group materi data for Lihat Mapel modal (same grouping logic)
    const groupMateriData = (items) => {
      if (!items || !items.length) return [];
      if (!items[0]?.kmp) {
        // fallback: no structured data, single group
        return [{ label: 'Mata Pelajaran', items }];
      }
      const groups = {};
      items.forEach((item) => {
        const key = `${item.kmp || '?'} - ${item.jkmp || '?'} - Kelas ${item.kelas || '?'}`;
        if (!groups[key]) groups[key] = { label: key, items: [] };
        groups[key].items.push(item);
      });
      return Object.values(groups);
    };

    // Styled group header for react-select
    const formatGroupLabel = (group) => (
      <div className="pgs-group-label">
        <span>{group.label}</span>
        <span className="pgs-group-badge">{group.options.length}</span>
      </div>
    );

    // Mapel tabs: auto-select first available tab
    const hasK13 = this.state.materiK13?.length > 0;
    const hasMerdeka = this.state.materiMerdeka?.length > 0;
    let activeMapelTab = this.state.activeMapelTab;
    if (!activeMapelTab) {
      activeMapelTab = hasMerdeka ? 'Merdeka' : (hasK13 ? 'K13' : 'Merdeka');
    }

    const anyFilterActive = this.state.showFilterTA || this.state.showFilterPenugasan || this.state.showFilterMapel;

    return (
      <div className="pgs-page">
        {/* ====== PREMIUM HEADER ====== */}
        <div className="pgs-header">
          <div className="pgs-header-content">
            <div className="pgs-header-left">
              <div className="pgs-header-icon-wrap">
                <i className="bx bx-user-check"></i>
              </div>
              <div>
                <h1 className="pgs-header-title">Penugasan Guru</h1>
                <p className="pgs-header-subtitle">Kelola penugasan dan pengampu mata pelajaran guru</p>
              </div>
            </div>
            <div className="pgs-header-actions">
              <button className="pgs-btn-tambah" onClick={this.showModalTambah}>
                <i className="bx bx-plus-circle"></i>
                Tambah Penugasan
              </button>
            </div>
          </div>
        </div>

        {/* ====== ALERT ====== */}
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        {/* ====== FILTER TOOLBAR ====== */}
        <div className="pgs-toolbar-card">
          <div className="pgs-toolbar">
            <div className="pgs-search-wrap">
              <i className="bx bx-search pgs-search-icon"></i>
              <input
                type="search"
                className="pgs-search-input"
                placeholder="Cari nama guru atau kode pendaftaran..."
                id="search"
                onChange={this.searchText}
              />
            </div>
            <div className="pgs-filter-chips">
              <button
                className={`pgs-filter-chip ${this.state.showFilterTA ? 'active' : ''}`}
                onClick={() => this.setState({ showFilterTA: !this.state.showFilterTA })}
              >
                <i className="bx bx-calendar"></i> Tahun Ajaran
              </button>
              <button
                className={`pgs-filter-chip ${this.state.showFilterPenugasan ? 'active' : ''}`}
                onClick={() => this.setState({ showFilterPenugasan: !this.state.showFilterPenugasan })}
              >
                <i className="bx bx-briefcase"></i> Penugasan
              </button>
              <button
                className={`pgs-filter-chip ${this.state.showFilterMapel ? 'active' : ''}`}
                onClick={() => this.setState({ showFilterMapel: !this.state.showFilterMapel })}
              >
                <i className="bx bx-book"></i> Mata Pelajaran
              </button>
              {anyFilterActive && (
                <button onClick={this.setFilter} className="pgs-btn-cari">
                  <i className="bx bx-search-alt"></i>
                  {this.state.loading_button === true ? "Tunggu..." : "Terapkan"}
                </button>
              )}
            </div>
          </div>

          {/* Active filter dropdowns */}
          {anyFilterActive && (
            <div className="pgs-filter-active">
              {this.state.showFilterTA && (
                <div className="pgs-filter-active-item">
                  <div className="pgs-filter-active-label">Tahun Ajaran</div>
                  <Select
                    styles={pgsSelectStyles}
                    isClearable
                    options={this.state.data_tahun_ajaran}
                    onChange={this.filterTahunAjaran}
                    placeholder="Pilih tahun ajaran..."
                  />
                </div>
              )}
              {this.state.showFilterPenugasan && (
                <div className="pgs-filter-active-item">
                  <div className="pgs-filter-active-label">Penugasan</div>
                  <Select
                    styles={pgsSelectStyles}
                    isClearable
                    options={this.state.data_penugasan}
                    onChange={this.filterPenugasan}
                    placeholder="Pilih penugasan..."
                  />
                </div>
              )}
              {this.state.showFilterMapel && (
                <div className="pgs-filter-active-item">
                  <div className="pgs-filter-active-label">Mata Pelajaran</div>
                  <Select
                    styles={pgsSelectStyles}
                    isClearable
                    options={this.state.data_pengampu}
                    onChange={this.filterPengamuSc}
                    placeholder="Pilih mata pelajaran..."
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* ====== DATA TABLE ====== */}
        <div className="pgs-table-card">
          <DataTable
            ref={(dt) => { this.dt = dt; }}
            action={{
              jenis_kelamin: (col, data) => {
                var jekel = "";
                if (col.jenis_kelamin == 1) jekel = "Laki-laki";
                else if (col.jenis_kelamin == 0) jekel = "Perempuan";
                else jekel = "Belum diketahui";
                return <span style={{ fontSize: '0.85rem', color: '#334155' }}>{jekel}</span>;
              },

              inisial: (col, data) => {
                var inisial = "";
                var potong = "";
                var potong2 = "";
                var potong4 = "";
                var potong5 = "";
                if (col.inisial !== null) {
                  inisial = col.inisial;
                } else if (col.nama_guru !== null) {
                  potong = col.nama_guru.substr(0, 3);
                  potong2 = col.nama_guru.substr(0, 2);
                  potong4 = col.nama_guru.substr(0, 4);
                  potong5 = col.nama_guru.substr(0, 5);
                  if (potong == "Dr.") { inisial = col.nama_guru.substr(4, 3); }
                  else if (potong4 == "Drs.") { inisial = col.nama_guru.substr(5, 3); }
                  else if (potong == "Ir.") { inisial = col.nama_guru.substr(4, 3); }
                  else if (potong5 == "Prof.") { inisial = col.nama_guru.substr(6, 3); }
                  else if (potong2 == "H.") { inisial = col.nama_guru.substr(3, 3); }
                  else if (potong == "Hj.") { inisial = col.nama_guru.substr(4, 3); }
                  else { inisial = potong; }
                }
                return <span className="pgs-inisial-badge">{inisial}</span>;
              },

              mata_pelajaran: (col, data) => {
                return (
                  <button
                    onClick={this.showModalMateri.bind(this, data.id_penugasan)}
                    disabled={this.state.loading_view === data.id_penugasan}
                    className="pgs-btn-view"
                  >
                    {this.state.loading_view === data.id_penugasan ? (
                      <UserButtonLoading color="text-blue-700" />
                    ) : (
                      <>
                        <i className="bx bx-book-open"></i>
                        Lihat
                      </>
                    )}
                  </button>
                );
              },

              aksi: (col, data) => {
                return (
                  <div className="pgs-actions">
                    <button
                      onClick={this.showModalEdit.bind(this, data.id_penugasan)}
                      className="pgs-btn-edit"
                      title="Edit Penugasan"
                    >
                      <i className="bx bx-edit-alt"></i>
                    </button>
                    <button
                      onClick={this.deletePenugasan.bind(this, data.id_penugasan)}
                      className="pgs-btn-delete"
                      disabled={this.state.loading_delete === true}
                      title="Hapus Penugasan"
                    >
                      {this.state.loading_delete === true ? (
                        <UserButtonLoading color="text-red-600" loadingText={null} />
                      ) : (
                        <i className="bx bx-trash"></i>
                      )}
                    </button>
                    {this.state.loading_check === false && (
                      <input
                        type="checkbox"
                        name="check_data[]"
                        id={data.id_penugasan}
                        value={data.id_penugasan}
                        onChange={this.selectOne}
                        className="pgs-checkbox"
                        defaultChecked={this.state.checkAll}
                      />
                    )}
                  </div>
                );
              },
            }}
            url={this.state.url + this.state.institusi_id_select + "/GU"}
            columns={[
              { index: "tahun_ajaran", label: "Tahun Ajaran" },
              { index: "kode_pendaftaran", label: "Kode Pendaftaran" },
              { index: "nama_guru", label: "Nama Guru" },
              { index: "inisial", label: "Inisial" },
              { index: "tanggal_lahir", label: "Tgl Lahir" },
              { index: "jenis_kelamin", label: "Jenis Kelamin" },
              { index: "nama_penugasan", label: "Penugasan" },
              { index: "penugasansub", label: "Sub Penugasan" },
              { index: "mata_pelajaran", label: "Mata Pelajaran" },
              { index: "aksi", label: "Aksi" },
            ]}
          />
        </div>

        {/* ====== BULK ACTIONS BAR ====== */}
        {this.state.url_show_data != "" && (
          <div className="pgs-bulk-bar">
            <div className="pgs-bulk-info">
              <i className="bx bx-check-double"></i>
              <span>Pilih data guru lalu gunakan aksi di bawah ini</span>
            </div>
            <div className="pgs-bulk-actions">
              {this.state.checkAll === false ? (
                <button className="pgs-btn-select-all" onClick={this.checkAll}>
                  <i className="bx bx-select-multiple"></i>
                  Pilih Semua
                </button>
              ) : (
                <button className="pgs-btn-select-all active" onClick={this.unCheckAll}>
                  <i className="bx bx-check-double"></i>
                  Batal Pilih
                </button>
              )}
              <button
                onClick={this.pindahTa}
                className="pgs-btn-pindah-ta"
                disabled={this.state.loading_pindah_ta === true}
              >
                <i className="bx bx-transfer-alt"></i>
                {this.state.loading_pindah_ta ? <UserButtonLoading /> : "Pindah Tahun Ajaran"}
              </button>
              <button
                onClick={this.deleteMulti}
                className="pgs-btn-hapus-multi"
                disabled={this.state.loading_delete === true}
              >
                <i className="bx bx-trash"></i>
                {this.state.loading_delete ? <UserButtonLoading /> : "Hapus Terpilih"}
              </button>
            </div>
          </div>
        )}

        {/* ====== MODAL TAMBAH ====== */}
        <Modal show={this.state.modal_tambah} onHide={this.hideModalTambah} dialogClassName="pgs-modal">
          <Modal.Header>
            <div className="pgs-modal-header">
              <div className="pgs-modal-header-content">
                <i className="bx bx-plus-circle pgs-modal-icon"></i>
                <div>
                  <h3>Tambah Penugasan Guru</h3>
                  <p>Isi data penugasan guru baru</p>
                </div>
              </div>
              <button className="pgs-modal-close" onClick={this.hideModalTambah}>
                <i className="bx bx-x"></i>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div className="pgs-modal-body">
              <div className="pgs-info-box">
                <i className="bx bx-info-circle"></i>
                <span>
                  Pilih <strong>Guru</strong> → <strong>Penugasan</strong> → <strong>Kurikulum</strong> (K13 / Merdeka).
                  Setelah memilih kurikulum, form pengampu mata pelajaran akan muncul otomatis sesuai kurikulum yang dipilih.
                </span>
              </div>

              <form onSubmit={this.create_penugasan}>
                <div className="pgs-form-group">
                  <label className="pgs-form-label">
                    Nama Guru <span className="required">*</span>
                  </label>
                  <Select
                    styles={pgsSelectStyles}
                    options={this.state.data_nama_guru}
                    placeholder="Pilih Nama Guru..."
                    onChange={this.nama}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                <div className="pgs-form-group">
                  <label className="pgs-form-label">
                    Penugasan <span className="required">*</span>
                  </label>
                  <Select
                    styles={pgsSelectStyles}
                    options={this.state.data_penugasan}
                    isMulti
                    placeholder="Pilih Penugasan..."
                    onChange={this.penugasan}
                    components={animatedComponent}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                  <span className="pgs-form-hint">Bisa memilih lebih dari satu penugasan</span>
                </div>

                <div className="pgs-form-group">
                  <label className="pgs-form-label">
                    Kurikulum <span className="required">*</span>
                  </label>
                  <Select
                    styles={pgsSelectStyles}
                    options={dataKurikulum}
                    isMulti
                    placeholder="Pilih Kurikulum (K13 / Merdeka)..."
                    onChange={this.kurikulum}
                    components={animatedComponent}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                  <span className="pgs-form-hint">Pilih kurikulum untuk menampilkan daftar mata pelajaran pengampu</span>
                </div>

                {/* Pengampu Cards per kurikulum */}
                {this.state.kurikulum && this.state.kurikulum?.map((values, idx) => {
                  let value = values?.value ?? "";
                  let isK13 = value === "K13";
                  return (
                    <div key={idx} className={`pgs-kurikulum-card ${isK13 ? 'pgs-kurikulum-card-k13' : 'pgs-kurikulum-card-merdeka'}`}>
                      <div className="pgs-kurikulum-card-header">
                        <span className={`pgs-kurikulum-badge ${isK13 ? 'pgs-kurikulum-badge-k13' : 'pgs-kurikulum-badge-merdeka'}`}>
                          <i className={`bx ${isK13 ? 'bx-book' : 'bx-rocket'}`}></i>
                          {isK13 ? 'Kurikulum 2013 (K13)' : 'Kurikulum Merdeka'}
                        </span>
                        <span className="pgs-kurikulum-desc">
                          {isK13 ? 'Mata pelajaran berdasarkan kurikulum 2013' : 'Mata pelajaran berdasarkan kurikulum merdeka belajar'}
                        </span>
                      </div>
                      <label className="pgs-form-label">Pilih Mata Pelajaran Pengampu</label>
                      <Select
                        styles={isK13 ? pgsSelectStyles : pgsSelectStylesGreen}
                        isMulti
                        placeholder={`Pilih mata pelajaran ${value}...`}
                        options={groupMapelOptions(value === "Merdeka" ? this.state.data_pengampu_merdeka : this.state.data_pengampu)}
                        onChange={(e) => { this.pengampu(e, values) }}
                        formatOptionLabel={formatMapelLabel}
                        formatGroupLabel={formatGroupLabel}
                        filterOption={filterMapelOption}
                        components={optimizedComponents}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        closeMenuOnSelect={false}
                      />
                    </div>
                  );
                })}

                <div className="pgs-form-group">
                  <label className="pgs-form-label">
                    Tahun Ajaran <span className="required">*</span>
                  </label>
                  <Select
                    styles={pgsSelectStyles}
                    placeholder="Pilih Tahun Ajaran..."
                    options={this.state.data_tahun_ajaran}
                    onChange={this.tahun_ajaran}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                <div className="pgs-modal-footer" style={{ padding: '1rem 0 0' }}>
                  <button type="button" className="pgs-btn-cancel" onClick={this.hideModalTambah}>
                    Batal
                  </button>
                  <button
                    type="submit"
                    className="pgs-btn-submit"
                    disabled={this.state.simpleLoading}
                  >
                    {this.state.simpleLoading ? (
                      <><UserButtonLoading color="text-white" /> Menyimpan...</>
                    ) : (
                      <><i className="bx bx-check"></i> Tambah Penugasan</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        {/* ====== MODAL EDIT ====== */}
        <Modal show={this.state.modal_edit} onHide={this.hideModalEdit} dialogClassName="pgs-modal">
          <Modal.Header>
            <div className="pgs-modal-header pgs-modal-header-edit">
              <div className="pgs-modal-header-content">
                <i className="bx bx-edit-alt pgs-modal-icon"></i>
                <div>
                  <h3>Edit Penugasan Guru</h3>
                  <p>Perbarui data penugasan</p>
                </div>
              </div>
              <button className="pgs-modal-close" onClick={this.hideModalEdit}>
                <i className="bx bx-x"></i>
              </button>
            </div>
          </Modal.Header>
          {this.state.loading_edit ? (
            <Modal.Body><UserEditSkeleton /></Modal.Body>
          ) : (
            <Modal.Body style={{ padding: 0 }}>
              <div className="pgs-modal-body">
                <form onSubmit={this.update_penugasan}>
                  {/* Guru badge read-only */}
                  <div className="pgs-form-group">
                    <label className="pgs-form-label">Nama Guru</label>
                    {this.state.nama_select && this.state.nama_select.length > 0 && (
                      <div className="pgs-guru-badge">
                        <div className="pgs-guru-avatar">
                          <i className="bx bx-user"></i>
                        </div>
                        <div>
                          <span className="pgs-guru-name">{this.state.nama_select[0]?.label}</span>
                          <span className="pgs-guru-label">Guru tetap • Tidak dapat diubah</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pgs-form-group">
                    <label className="pgs-form-label">Penugasan <span className="required">*</span></label>
                    <Select
                      styles={pgsSelectStyles}
                      placeholder="Pilih Penugasan..."
                      isMulti
                      defaultValue={this.state.penugasan_select != "" ? this.state.penugasan_select : null}
                      options={this.state.data_penugasan}
                      onChange={this.penugasan}
                      components={animatedComponent}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  <div className="pgs-form-group">
                    <label className="pgs-form-label">Kurikulum <span className="required">*</span></label>
                    <Select
                      styles={pgsSelectStyles}
                      placeholder="Pilih Kurikulum..."
                      isMulti
                      defaultValue={this.state.kurikulum_select != "" ? this.state.kurikulum_select : null}
                      options={dataKurikulum}
                      onChange={this.kurikulum}
                      components={animatedComponent}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  {/* Pengampu Cards per kurikulum */}
                  {this.state.kurikulum_select && this.state.kurikulum_select?.map((values, idx) => {
                    let value = values?.value ?? null;
                    let isK13 = value === "K13";
                    return (
                      <div key={idx} className={`pgs-kurikulum-card ${isK13 ? 'pgs-kurikulum-card-k13' : 'pgs-kurikulum-card-merdeka'}`}>
                        <div className="pgs-kurikulum-card-header">
                          <span className={`pgs-kurikulum-badge ${isK13 ? 'pgs-kurikulum-badge-k13' : 'pgs-kurikulum-badge-merdeka'}`}>
                            <i className={`bx ${isK13 ? 'bx-book' : 'bx-rocket'}`}></i>
                            {isK13 ? 'Kurikulum 2013 (K13)' : 'Kurikulum Merdeka'}
                          </span>
                          <span className="pgs-kurikulum-desc">
                            {isK13 ? 'Daftar mata pelajaran K13' : 'Daftar mata pelajaran Merdeka'}
                          </span>
                        </div>
                        <label className="pgs-form-label">Pilih Mata Pelajaran Pengampu</label>
                        <Select
                          styles={isK13 ? pgsSelectStyles : pgsSelectStylesGreen}
                          placeholder={`Pilih mata pelajaran ${value}...`}
                          isMulti
                          defaultValue={value === 'Merdeka' ? this.state.pengampu_merdeka : this.state.pengampu}
                          options={groupMapelOptions(value === 'Merdeka' ? this.state.data_pengampu_merdeka : this.state.data_pengampu)}
                          onChange={(e) => { this.pengampu(e, values); }}
                          formatOptionLabel={formatMapelLabel}
                          formatGroupLabel={formatGroupLabel}
                          filterOption={filterMapelOption}
                          components={optimizedComponents}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          closeMenuOnSelect={false}
                          ref={(ref) => { this.selectRef = ref; }}
                        />
                      </div>
                    );
                  })}

                  <div className="pgs-form-group">
                    <label className="pgs-form-label">Tahun Ajaran <span className="required">*</span></label>
                    <Select
                      styles={pgsSelectStyles}
                      placeholder="Pilih Tahun Ajaran..."
                      defaultValue={this.state.tahun_ajaran_select != "" ? this.state.tahun_ajaran_select : null}
                      options={this.state.data_tahun_ajaran}
                      onChange={this.tahun_ajaran}
                      components={animatedComponent}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  <div className="pgs-modal-footer" style={{ padding: '1rem 0 0' }}>
                    <button type="button" className="pgs-btn-cancel" onClick={this.hideModalEdit}>
                      Batal
                    </button>
                    {this.state.loading_saveedit ? (
                      <button className="pgs-btn-submit pgs-btn-submit-edit" disabled>
                        <UserButtonLoading color="text-white" /> Menyimpan...
                      </button>
                    ) : (
                      <button type="submit" className="pgs-btn-submit pgs-btn-submit-edit">
                        <i className="bx bx-check"></i> Simpan Perubahan
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </Modal.Body>
          )}
        </Modal>

        {/* ====== MODAL LIHAT MATA PELAJARAN ====== */}
        <Modal show={this.state.modal_materi} onHide={this.hideModalMateri} dialogClassName="pgs-modal">
          <Modal.Header>
            <div className="pgs-modal-header pgs-modal-header-mapel">
              <div className="pgs-modal-header-content">
                <i className="bx bx-book-open pgs-modal-icon"></i>
                <div>
                  <h3>Daftar Mata Pelajaran</h3>
                  <p>Mata pelajaran yang diampu berdasarkan kurikulum</p>
                </div>
              </div>
              <button className="pgs-modal-close" onClick={this.hideModalMateri}>
                <i className="bx bx-x"></i>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div className="pgs-modal-body">
              {/* Custom Tabs - only show tabs that have data */}
              <div className="pgs-mapel-tabs">
                {hasMerdeka && (
                  <button
                    className={`pgs-mapel-tab ${activeMapelTab === 'Merdeka' ? 'active merdeka' : ''}`}
                    onClick={() => this.setState({ activeMapelTab: 'Merdeka' })}
                  >
                    <i className="bx bx-rocket"></i>
                    Kurikulum Merdeka
                    <span className="pgs-mapel-count">{this.state.materiMerdeka?.length}</span>
                  </button>
                )}
                {hasK13 && (
                  <button
                    className={`pgs-mapel-tab ${activeMapelTab === 'K13' ? 'active' : ''}`}
                    onClick={() => this.setState({ activeMapelTab: 'K13' })}
                  >
                    <i className="bx bx-book"></i>
                    Kurikulum 2013
                    <span className="pgs-mapel-count">{this.state.materiK13?.length}</span>
                  </button>
                )}
              </div>

              {/* No data at all */}
              {!hasK13 && !hasMerdeka && (
                <div className="pgs-mapel-empty">
                  <i className="bx bx-book-open"></i>
                  <p>Belum ada mata pelajaran yang ditugaskan</p>
                </div>
              )}

              {/* Merdeka Tab Content */}
              {activeMapelTab === 'Merdeka' && hasMerdeka && (
                <div className="pgs-mapel-grouped">
                  {groupMateriData(this.state.materiMerdeka).map((group, gi) => (
                    <div key={gi} className="pgs-mapel-group">
                      <div className="pgs-group-label">
                        <span>{group.label}</span>
                        <span className="pgs-group-badge">{group.items.length}</span>
                      </div>
                      <table className="pgs-mapel-table">
                        <tbody>
                          {group.items.map((value, index) => (
                            <tr key={value.id_materi || index}>
                              <td className="pgs-mapel-no">{index + 1}</td>
                              <td>
                                <span className="pgs-option-nama">{value.mp || value.materi}</span>
                                {value.indeks_mpk && <span className="pgs-option-kode" style={{ marginLeft: 8 }}>{value.indeks_mpk}</span>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>
              )}

              {/* K13 Tab Content */}
              {activeMapelTab === 'K13' && hasK13 && (
                <div className="pgs-mapel-grouped">
                  {groupMateriData(this.state.materiK13).map((group, gi) => (
                    <div key={gi} className="pgs-mapel-group">
                      <div className="pgs-group-label">
                        <span>{group.label}</span>
                        <span className="pgs-group-badge">{group.items.length}</span>
                      </div>
                      <table className="pgs-mapel-table">
                        <tbody>
                          {group.items.map((value, index) => (
                            <tr key={value.id_materi || index}>
                              <td className="pgs-mapel-no">{index + 1}</td>
                              <td>
                                <span className="pgs-option-nama">{value.mp || value.materi}</span>
                                {value.indeks_mpk && <span className="pgs-option-kode" style={{ marginLeft: 8 }}>{value.indeks_mpk}</span>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="pgs-modal-footer">
              <button className="pgs-btn-cancel" onClick={this.hideModalMateri}>
                <i className="bx bx-x"></i> Tutup
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* ====== MODAL PINDAH TA ====== */}
        <Modal size="sm" show={this.state.modal_pindah_ta} onHide={this.hideModalTa} dialogClassName="pgs-modal">
          <Modal.Header>
            <div className="pgs-modal-header pgs-modal-header-ta">
              <div className="pgs-modal-header-content">
                <i className="bx bx-transfer-alt pgs-modal-icon"></i>
                <div>
                  <h3>Pindah Tahun Ajaran</h3>
                  <p>Pindahkan penugasan terpilih</p>
                </div>
              </div>
              <button className="pgs-modal-close" onClick={this.hideModalTa}>
                <i className="bx bx-x"></i>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div className="pgs-modal-body">
              <div className="pgs-info-box">
                <i className="bx bx-info-circle"></i>
                <span>Pilih tahun ajaran tujuan untuk memindahkan penugasan yang telah dipilih.</span>
              </div>
              <div className="pgs-form-group">
                <label className="pgs-form-label">Tahun Ajaran Tujuan <span className="required">*</span></label>
                <Select
                  id="filterTahunAjaran"
                  styles={pgsSelectStyles}
                  isClearable
                  options={this.state.data_tahun_ajaran}
                  onChange={this.filterPindahTa}
                  placeholder="Pilih Tahun Ajaran..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="pgs-modal-footer" style={{ padding: '1rem 0 0' }}>
                <button className="pgs-btn-cancel" onClick={this.hideModalTa}>
                  Batal
                </button>
                <button className="pgs-btn-submit" style={{ background: 'linear-gradient(135deg, #059669, #10b981)' }} onClick={this.savePindahTa}>
                  <i className="bx bx-transfer-alt"></i> Pindahkan
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
